import React, { useState, useEffect, useRef } from 'react';
import styles from './style.less';

interface IProps {
  minute: number;
}

const CountDown: React.FC<IProps> = ({ minute }) => {
  const intervalRef = useRef<any>(null);
  const timeStamp = new Date().getTime() + minute * 60000;
  const now: any = new Date().getTime(); // 获取当前时间
  const end: any = timeStamp; // 设置截止时间

  const [diffTime, setDiffTime] = useState(end - now); // 时间间隔
  const [, setHours] = useState<string>('0'); // 小时
  const [m, setMinutes] = useState<string>('00'); // 分钟
  const [s, setSeconds] = useState<string>('00'); // 秒
  const [ms, setMs] = useState<string>('000'); // 毫秒

  useEffect(() => {
    if (diffTime > 0) {
      intervalRef.current = setInterval(() => {
        const newNow: any = new Date().getTime(); // 重新获取当前时间
        const newDiffTime = timeStamp - newNow;

        setDiffTime(() => newDiffTime); // 计算新的时间间隔数值

        // const d = Math.floor(newDiffTime / (1000 * 60 * 60 * 24));
        const h1 = Math.floor((newDiffTime / (1000 * 60 * 60)) % 60);
        const m1 = Math.floor((newDiffTime / (1000 * 60)) % 60);
        const s1 = Math.floor((newDiffTime / 1000) % 60);
        const ms1 = Math.floor(newDiffTime % 1000);
        const randomMs = `${ms1.toString()[0]}${Math.floor(Math.random() * 10)}`;

        setHours(() => (h1 < 10 ? `0${h1}` : `${h1}`)); // 设置小时
        setMinutes(() => (m1 < 10 ? `0${m1}` : `${m1}`)); // 设置分钟
        setSeconds(() => (s1 < 10 ? `0${s1}` : `${s1}`)); // 保证值在setInterval里更新，避免useEffect的bug
        setMs(() => randomMs);
      }, 100);
    } else {
      setDiffTime(0);
      setHours('00');
      setMinutes('00');
      setSeconds('00');
      setMs('00');
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, []); // 不传依赖

  return <>{diffTime > 0 && <div className={styles.countDown}>{`${m}:${s}.${ms}`}</div>}</>;
};

export default CountDown;
